import { BackButton, Box, FloatingContainer, Row, Screen, Text } from '~/commonComponents';
import { ShiftPendingReviews } from './ShiftPendingReviews';

export const ShiftPendingReviewsScreen = () => {
  return (
    <Screen>
      <FloatingContainer>
        <Row
          alignItems="center"
          justifyContent="center"
          marginBottom={32}
          marginTop={44}
          position="relative"
        >
          <Box position="absolute" left={0}>
            <BackButton />
          </Box>
          <Text bold fontSize={32}>
            Pending Review
          </Text>
        </Row>
        <Box paddingHorizontal={32}>
          <ShiftPendingReviews />
        </Box>
      </FloatingContainer>
    </Screen>
  );
};
